import type { RecipeSearchParams } from '@/lib/api/requests/recipes';

const EMPTY_RECIPE_SEARCH_PARAMS: RecipeSearchParams = {} as RecipeSearchParams;

export const recipeKeys = {
  all: ['recipes'] as const,
  lists: () => [...recipeKeys.all, 'list'] as const,
  list: (params?: RecipeSearchParams) =>
    [...recipeKeys.lists(), params ?? EMPTY_RECIPE_SEARCH_PARAMS] as const,
  details: () => [...recipeKeys.all, 'detail'] as const,
  detail: (id: number) => [...recipeKeys.details(), id] as const,
  categories: () => [...recipeKeys.all, 'categories'] as const,
  allergens: (id: number) => [...recipeKeys.all, 'allergens', id] as const,
  availability: (recipeId: number, locationId: number) =>
    [...recipeKeys.all, 'availability', recipeId, locationId] as const,
  shelfLife: (recipeId: string, params?: object) => [...recipeKeys.all, 'shelf-life', recipeId, params ?? {}] as const,
  costSummary: (recipeId: number) => [...recipeKeys.all, 'cost-summary', recipeId] as const,
  stages: (recipeId: number) => [...recipeKeys.all, 'stages', recipeId] as const,
  usedIn: (recipeId: number) => [...recipeKeys.all, 'used-in', recipeId] as const,
  materialUsage: (materialId: number) => [...recipeKeys.all, 'uses-material', materialId] as const,
  ingredients: (recipeId: number, params?: object) => [...recipeKeys.all, 'ingredients', recipeId, params ?? {}] as const,
  storageContainers: (recipeId: number, params?: object) => [...recipeKeys.all, 'storage-containers', recipeId, params ?? {}] as const,
  tools: (recipeId: number, params?: object) => [...recipeKeys.all, 'tools', recipeId, params ?? {}] as const,
};
